let config = {
  sdk: 'NIM_Web_SDK_v4.2.0.js',
  // 用户自定义的登录注册地址
  loginUrl: '/wxlogin.html',
  registUrl: '/regist.html',
  homeUrl: '/index?',

  // 资源路径根目录，为了方便用户部署在二级以上URL路径上
  resourceUrl: 'http://yx-web.nos.netease.com/webdoc/h5',
  // 用户logo地址
  logo: 'http://yx-web.nos.netease.com/webdoc/h5/im/logo.png',
  // 默认用户头像
  defaultUserIcon: 'http://yx-web.nos.netease.com/webdoc/h5/im/default-icon.png',
  // 系统通知图标
  noticeIcon: 'http://yx-web.nos.netease.com/webdoc/h5/im/notice-icon.png',
  // 我的手机图标
  myPhoneIcon: 'http://yx-web.nos.netease.com/webdoc/h5/im/my-phone.png',
  // 本地消息显示数量，会影响性能
  localMsglimit: 36
}

const env = 'online'

let appConfig = {
  // 用户的appkey
  // 用于在web demo中注册账号异步请求demo 服务器中使用
  test: {
    appkey: 'b674a21c3b971381d66e7f534b802057',
    postUrl: 'https://app.netease.im'
  },
  online: {
    appkey: 'b674a21c3b971381d66e7f534b802057',
    postUrl: 'https://app.netease.im'
  }
}

config = Object.assign(config, appConfig[env])

export default config





// WEBPACK FOOTER //
// ./src/configs/index.js